import React, { useEffect, useState, useCallback } from "react";
import { Plus, Trash2, ArrowUp, ArrowDown, Check, Pencil } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const load = useCallback(() => { api.get("/categories").then(({ data }) => setCats(data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!name.trim()) return;
    await api.post("/admin/categories", { name: name.trim() });
    setName(""); load(); toast.success("Category added");
  };
  const rename = async (id) => { await api.put(`/admin/categories/${id}`, { name: editName }); setEditId(null); load(); };
  const remove = async (id) => { if (!window.confirm("Delete category?")) return; await api.delete(`/admin/categories/${id}`); load(); };
  const move = async (i, dir) => {
    const arr = [...cats];
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    setCats(arr);
    await api.put("/admin/categories/reorder", arr.map((c) => c.id));
  };

  return (
    <div data-testid="admin-categories">
      <h1 className="font-heading font-black uppercase text-xl text-[#F0EDEA] mb-4">Categories</h1>
      <div className="flex gap-2 mb-4">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="New category" className="flex-1 bg-[#141414] border border-[#333] rounded-lg h-11 px-3 text-[#F0EDEA] focus:border-[#E60000] outline-none" data-testid="new-category-input" />
        <button onClick={add} className="btn-skew btn-primary text-xs" data-testid="add-category-btn"><span><Plus size={16} /> Add</span></button>
      </div>
      <div className="space-y-2">
        {cats.map((c, i) => (
          <div key={c.id} className="bg-[#1C1C1C] border border-[#333] rounded-xl px-3 py-2 flex items-center gap-2" data-testid={`category-${c.id}`}>
            {editId === c.id ? (
              <>
                <input value={editName} onChange={(e) => setEditName(e.target.value)} className="flex-1 bg-[#141414] border border-[#333] rounded h-9 px-2 text-[#F0EDEA]" />
                <button onClick={() => rename(c.id)} className="text-green-400"><Check size={18} /></button>
              </>
            ) : (
              <>
                <span className="flex-1 text-[#F0EDEA]">{c.name}</span>
                <button onClick={() => move(i, -1)} className="text-[#A8A2A0] hover:text-[#E60000]"><ArrowUp size={16} /></button>
                <button onClick={() => move(i, 1)} className="text-[#A8A2A0] hover:text-[#E60000]"><ArrowDown size={16} /></button>
                <button onClick={() => { setEditId(c.id); setEditName(c.name); }} className="text-[#A8A2A0] hover:text-[#E60000]"><Pencil size={16} /></button>
                <button onClick={() => remove(c.id)} className="text-[#A8A2A0] hover:text-[#E60000]"><Trash2 size={16} /></button>
              </>
            )}
          </div>
        ))}
        {cats.length === 0 && <div className="text-[#A8A2A0] text-center py-8">No categories yet.</div>}
      </div>
    </div>
  );
}
